import React from "react";
import { useTranslation } from "react-i18next";
import { API_BASE_URL } from "../common/config";
import { useAppContext } from "../AppContext";
import { isKnmtPractice } from "../onboarding/onboarding";

// The how-to videos are hosted with the website (server/website/vid) and served at /vid on every host.
// KNMT practices get their own video built around the KNMT starter set.
const HowToVideo = ({ className = "", autoPlay = false }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith("nl") ? "nl" : "en";
  const { currentUser } = useAppContext();
  const variant = isKnmtPractice(currentUser) ? "knmt-" : "";
  const base = `${API_BASE_URL}/vid/risqui-howto-${variant}${lang}`;

  return (
    <video
      key={base}
      className={`howto-video ${className}`}
      controls
      playsInline
      autoPlay={autoPlay}
      preload={autoPlay ? "auto" : "none"}
      poster={`${base}.jpg`}
      aria-label={t("help.video_label")}
    >
      <source src={`${base}.mp4`} type="video/mp4" />
    </video>
  );
};

export default HowToVideo;
